/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-west-2",
    "aws_cognito_identity_pool_id": "us-west-2:24ac0877-5dba-447c-8114-2ab621654f7b",
    "aws_cognito_region": "us-west-2",
    "aws_user_pools_id": "us-west-2_hCLHdK8Ja",
    "aws_user_pools_web_client_id": "553h5ldpi6ctiv3an3l07cv48g",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_content_delivery_bucket": "palilaxplayerportal-20230308125440-hostingbucket-prod",
    "aws_content_delivery_bucket_region": "us-west-2",
    "aws_content_delivery_url": "https://d1hqd0q4073dj1.cloudfront.net",
    "aws_cloud_logic_custom": [
        {
            "name": "AdminApi",
            "endpoint": "https://lu3lknbow3.execute-api.us-west-2.amazonaws.com/prod",
            "region": "us-west-2"
        },
        {
            "name": "UserApi",
            "endpoint": "https://ldw1chst2c.execute-api.us-west-2.amazonaws.com/prod",
            "region": "us-west-2"
        },
        {
            "name": "PublicApi",
            "endpoint": "https://50srhfy63i.execute-api.us-west-2.amazonaws.com/prod",
            "region": "us-west-2"
        }
    ]
};


export default awsmobile;
